// extracted by mini-css-extract-plugin
module.exports = {"rpmIcon":"RpmIcon_rpmIcon__2JEgL","translateFix":"RpmIcon_translateFix__1N3t9","scaleFix":"RpmIcon_scaleFix__1Kn2T","scaleAltFix":"RpmIcon_scaleAltFix__e1rA2"};